import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'

import { AgreementRequirementForm } from '../ClosingRequirements/forms/agreements/AgreementsRequirementsForm'
import { SchedulesRequirementForm } from '../ClosingRequirements/forms/schedules/SchedulesRequirementForm'
import { CaptureCardRequirementForm } from '../ClosingRequirements/forms/payments/CaptureCardRequirementForm'
import { ClosingTypeVariant } from '../ClosingRequirements/typings'

export interface SimpleDialogProps {
  mode: ClosingTypeVariant
  onClose: () => void
}

export function ClosingRequrementsDialog({ mode, onClose }: SimpleDialogProps) {
  const open = !!mode

  const handleClose = () => onClose()

  const title =
    mode === 'agreement'
      ? 'Agreements'
      : mode === 'scheduling'
        ? 'Scheduling'
        : mode === 'card'
          ? 'Capture Card'
          : undefined

  const content =
    mode === 'agreement' ? (
      <AgreementRequirementForm onClose={onClose} />
    ) : mode === 'scheduling' ? (
      <SchedulesRequirementForm onClose={onClose} />
    ) : mode === 'card' ? (
      <CaptureCardRequirementForm onClose={onClose} />
    ) : null

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      scroll="paper" // one scroll area inside the paper
      PaperProps={{
        sx: {
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          boxSizing: 'border-box',
          borderRadius: { xs: 1, sm: 2 },
          overflow: 'hidden',

          height: {
            xs: '100dvh', // dynamic viewport height (fixes iOS 100vh bug)
            sm: 'auto',
          },
          maxHeight: {
            xs: '100dvh',
            sm: 564,
          },
          m: { xs: 0, sm: undefined }, // no outer margin on phones
          paddingTop: { xs: 'env(safe-area-inset-top)', sm: 0 },
          paddingBottom: { xs: 'env(safe-area-inset-bottom)', sm: 0 },
        },
      }}
    >
      {title && <DialogTitle>{title}</DialogTitle>}

      <DialogContent
        sx={{
          p: 0,
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          minHeight: 0,
          overflow: 'hidden', // inner form handles scroll
          width: '100%',
          maxWidth: '100%',
          boxSizing: 'border-box',
        }}
      >
        {content}
      </DialogContent>
    </Dialog>
  )
}
